import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject, tap } from 'rxjs';
import { Navigation } from 'app/core/navigation/navigation.types';
import { UserRightsService } from 'app/modules/masters/user-rights/user-rights.service';
import { SessionStorageService } from '../common/sessionStorage.service';

@Injectable({
    providedIn: 'root'
})
export class NavigationService
{
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient,private userRightsService: UserRightsService,
        private sessionStorageService: SessionStorageService )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation>
    {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation>
    {
        return this._httpClient.get<Navigation>('api/common/navigation').pipe(
            tap((navigation) => {
                let loggedInUserId = this.sessionStorageService.getProperty<number>(
                    "user",
                    "userId"
                  );
                  let companyId = this.sessionStorageService.getProperty<number>(
                    "user",
                    "companyId"
                  );
                if(loggedInUserId && companyId)
                    {
                    this.userRightsService.loadMenuNavigation({userId : loggedInUserId , companyId: companyId}).then((res) => { 
                        // console.log("custom menu assign" , res);
                        navigation.default = res.data;
                    });}
                  
                
                
                this._navigation.next(navigation);
            })
        );

    }
}
